import { Card, CardBody, CardHeader, Text } from 'components/Library'
import { useTranslation } from 'react-i18next'

/**
 * Vista que renderiza una página no encontrada.
 * @class
 */
const Page404 = () => {
  const { t } = useTranslation()

  return (
    <Card
      style={{
        margin: '2rem auto',
        width: '95%'
      }}
    >
      <CardHeader align="center" color="primary">
        {t('pages.not-found')}
      </CardHeader>
      <CardBody
        style={{
          fontSize: '2rem',
          padding: '2rem'
        }}
      >
        <Text
          align="center"
          size="large"
          weight="bold"
          style={{
            fontSize: '3rem',
            paddingBottom: '2rem'
          }}
        >
          Error 404
        </Text>
        <Text align="center" style={{ paddingBottom: '.5rem' }}>
          {t('pages.not-exists')}
        </Text>
        <Text align="center">{t('pages.verify-url')}</Text>
      </CardBody>
    </Card>
  )
}

export default Page404
